<template>
    <section id="venue" :class="{'transporter': carId == 1, 'caddy': carId == 2, 'crafter': carId == 3, 'amarok': carId == 4}" class="bg-cover bg-overlay-black-5 display-table height-100 no-padding width-100" :style="'height:' + windowHeight + 'px!important'">
        <div class="display-table-cell vertical-align-middle">
            <div class="container">
                <div class="row">
                    <div class="col-md-5 col-md-offset-7">
                        <div class="mb-outer bg-white border-round padding-13 position-relative">
                            <div class="mb-inner">
                                <h3 class="font-family-alt font-weight-700 letter-spacing-2 text-uppercase xs-title-small title-medium title-sideline-base-color vw-bold">Bliv inspireret</h3>
                                <!--<span class="display-block font-family-alt margin-4-5 no-margin-bottom no-margin-rl text-base-color title-small vw-body">{{ title }}</span>-->
                                <p class="margin-4-5 no-margin-bottom no-margin-rl text-large text-gray-dark-2 vw-body">
                                    <slot name="text"></slot>
                                </p>
                                <a rel="noopener" target="_blank" :href="buttonLink" class="btn btn-outline-black btn-medium margin-7 no-margin-bottom no-margin-rl">{{ buttonText }}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        },
        staticCarId: {
            type: [Number, String],
            required: true
        },
        buttonText: {
            type: String,
            required: true
        },
        buttonLink: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            windowHeight: 400,
            carId: 0
        }
    },
    created () {
        this.checkHeight()
        this.randomizer()
    },
    mounted () {
        this.slideShow()
    },
    methods: {
        slideShow () {
            if (this.staticCarId) {
                this.carId = this.staticCarId
                return
            }
            if (!this.carId) {
                this.carId = 1
            } else if (this.carId === 4) {
                this.carId = 1
            } else {
                this.carId = this.carId + 1
            }
        },
        randomizer () {
            let self = this
            setInterval(function () {
                self.slideShow()
            }, 5000)
        },
        checkHeight () {
            this.windowHeight = window.innerHeight
        }
    }
}
</script>
<style scoped>
    @media screen and (max-width: 460px){
        .mb-outer{
            width: 100%;
            padding: 0!important
        }
        .mb-inner{
            padding: 30px;
        }
    }
    @media screen and (max-width:468px){
        li{
            font-size: 12px;
        }
    }
    li{
        font-family: vw !important;
    }
</style>



// WEBPACK FOOTER //
// promo.vue?ec9eeb36